import { render } from "./home.vue?vue&type=template&id=037b2d0d&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=037b2d0d&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\leeno\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037b2d0d"]])

export default __exports__